// extracted by mini-css-extract-plugin
module.exports = {"membershipTitle":"planDetails_membershipTitle__3S4wU","btnContainer":"planDetails_btnContainer__wtLzz","memberShipListContainer":"planDetails_memberShipListContainer__dLfHP"};